import { Component, input } from "@angular/core";
import { EditOption } from "../../../models/edit-option.model";
import { FlightEditForm } from "../../form/flight-edit-form";
import { FlightEditLookups } from "../../form/flight-edit-lookups";
import { CrewMembersGroupComponent } from "./crew-members-group/crew-members-group.component";
import { PassengersGroupComponent } from "./passengers-group/passengers-group.component";
import { PilotsGroupComponent } from "./pilots-group/pilots-group.component";

/** Who is on board: the pilot and the copilot, the crew members, and the passengers. */
@Component({
    selector: "app-crew-tab",
    imports: [PilotsGroupComponent, CrewMembersGroupComponent, PassengersGroupComponent],
    templateUrl: "./crew-tab.component.html",
    styleUrl: "./crew-tab.component.scss",
})
export class CrewTabComponent {
    readonly form = input.required<FlightEditForm>();
    readonly lookups = input.required<FlightEditLookups>();
    /** The organization's crew members, and any one already on the flight that is no longer active. */
    readonly members = input.required<EditOption[]>();
}
